export const LOCAL_STORAGE_PASSWORD_PROTECTION_CREDENTIALS = 'password_protection_credentials';

export const PASSWORD_VALIDATION = {
  message: 'Must be at least 10 characters long',
  isValid: (password: string) => password?.length >= 10,
};
